import { Column, Scrolling } from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Card, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { getAllWarehouses } from '../../../services/apis';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';
const AdrestekiAraclariBosalt = ({
    formData,
    handleInputChange,
}) => {
    const { t } = useFormatMessage()
    const [warehouses, setWarehouses] = useState([]);
    const [zones, setZones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [showGrid, setShowGrid] = useState(false);
    const ref = useRef()
    const [showMovedVehiclesExport, setShowMovedVehiclesExport] = useState(false);
    const [movedVehicles, setMovedVehicles] = useState([]);

    useEffect(() => {
        getWarehouses()
    }, [])

    const fetchAddresses = async () => {
        setLoading(true);
        const body = {
            coordinate: document.getElementById("koordinant").value || null,
            direction: document.getElementById("yon").value || null,
            end_seq: document.getElementById("sira-end").value ? parseInt(document.getElementById("sira-end").value) : null,
            start_seq: document.getElementById("sira-start").value ? parseInt(document.getElementById("sira-start").value) : null,
            warehouse_id: parseInt(document.getElementById("depoAdi").childNodes[0].childNodes[0].value),
            zone_id: parseInt(document.getElementById("bolge").childNodes[0].childNodes[0].value)
        };

        try {
            const { data } = await api.post('/adress/getByParams', body);
            if (data.data === null) {
                setShowGrid(false);
                toast.error(t("Adres Bulunamadı"));
                return;
            }
            setAddresses(data.data || []);
            setShowGrid(true);
        } catch (error) {
            console.error(error);
            toast.error(t("Adres Listesi Alınırken hata oluştu"));
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        if (validateObject()) {
            setMovedVehicles([]);
            setShowMovedVehiclesExport(false);
            let body = {
                "coordinate": document.getElementById("koordinant").value,
                "create_user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                "direction": document.getElementById("yon").value,
                "end_seq": parseInt(document.getElementById("sira-end").value),
                "start_seq": parseInt(document.getElementById("sira-start").value),
                "warehouse_id": parseInt(document.getElementById("depoAdi").childNodes[0].childNodes[0].value),
                "zone_id": parseInt(document.getElementById("bolge").childNodes[0].childNodes[0].value)
            }
            try {
                const response = await api.post('/unloadVehicles', body);
                if (response.data.data.success) {
                    setMovedVehicles(response.data.data.moved_vehicles || []);
                    setShowMovedVehiclesExport(true);
                    toast.success(t(`${response.data.data.moved_count} araç başarıyla taşındı`));
                }
                fetchAddresses();
            }
            catch (error) {
                console.log(error);
                toast.error("Adresteki Araçları Boşaltırken hata oluştu")
            }
        }

    }
    const exportMovedVehicles = async () => {
        try {
            if (!movedVehicles || !Array.isArray(movedVehicles)) {
                toast.error('İndirilebilir veri bulunamadı');
                return;
            }

            const workbook = new ExcelJS.Workbook();

            // Şase Listesi sayfası
            const chassisSheet = workbook.addWorksheet('Şase Listesi');
            chassisSheet.getCell(1, 1).value = 'Şase Listesi';
            chassisSheet.getCell(1, 1).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '4472C4' }
            };
            chassisSheet.getCell(1, 1).font = { color: { argb: 'FFFFFF' }, bold: true };
            chassisSheet.getCell(1, 1).border = {
                top: { style: 'thin', color: { argb: 'D9D9D9' } },
                left: { style: 'thin', color: { argb: 'D9D9D9' } },
                bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                right: { style: 'thin', color: { argb: 'D9D9D9' } }
            };

            movedVehicles.forEach((vehicle, index) => {
                const dataRow = chassisSheet.getRow(index + 2);
                dataRow.getCell(1).value = vehicle;

                const isEvenRow = index % 2 === 0;
                dataRow.getCell(1).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: isEvenRow ? 'F2F2F2' : 'FFFFFF' }
                };
                dataRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                dataRow.getCell(1).border = {
                    top: { style: 'thin', color: { argb: 'D9D9D9' } },
                    left: { style: 'thin', color: { argb: 'D9D9D9' } },
                    bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                    right: { style: 'thin', color: { argb: 'D9D9D9' } }
                };
            });

            chassisSheet.getColumn(1).width = 25;

            // Parametreler sayfası
            const parameterSheet = workbook.addWorksheet('Parametreler');

            const warehouseSelect = document.getElementById("depoAdi").childNodes[0].childNodes[0];
            const zoneSelect = document.getElementById("bolge").childNodes[0].childNodes[0];
            const selectedWarehouse = warehouses.find(w => w.id === parseInt(warehouseSelect.value));
            const selectedZone = zones.find(z => z.id === parseInt(zoneSelect.value));

            const infoHeaders = ['Parametre', 'Değer'];
            const headerRow1 = parameterSheet.getRow(1);
            headerRow1.getCell(1).value = infoHeaders[0];
            headerRow1.getCell(2).value = infoHeaders[1];

            headerRow1.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '4472C4' }
                };
                cell.font = { color: { argb: 'FFFFFF' }, bold: true };
                cell.border = {
                    top: { style: 'thin', color: { argb: 'D9D9D9' } },
                    left: { style: 'thin', color: { argb: 'D9D9D9' } },
                    bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                    right: { style: 'thin', color: { argb: 'D9D9D9' } }
                };
            });

            const infoData = [
                ['Depo', selectedWarehouse?.warehouse_name || ''],
                ['Bölge', selectedZone?.zone_name || ''],
                ['Koordinat', document.getElementById("koordinant").value || ''],
                ['Yön', document.getElementById("yon").value || ''],
                ['Sıra', `${document.getElementById("sira-start").value || ''} - ${document.getElementById("sira-end").value || ''}`]
            ];

            let rowIndex = 2;
            infoData.forEach((row, index) => {
                const dataRow = parameterSheet.getRow(rowIndex);
                dataRow.getCell(1).value = row[0];
                dataRow.getCell(2).value = row[1];

                const isEvenRow = index % 2 === 0;
                dataRow.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: isEvenRow ? 'F2F2F2' : 'FFFFFF' }
                    };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'D9D9D9' } },
                        left: { style: 'thin', color: { argb: 'D9D9D9' } },
                        bottom: { style: 'thin', color: { argb: 'D9D9D9' } },
                        right: { style: 'thin', color: { argb: 'D9D9D9' } }
                    };
                });
                dataRow.getCell(1).font = { bold: true };
                rowIndex++;
            });

            parameterSheet.getColumn(1).width = 25;
            parameterSheet.getColumn(2).width = 40;

            // Excel dosyasını kaydet
            const filename = `Tasinan_Araclar_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), filename);

        } catch (error) {
            console.error('Excel indirme hatası:', error);
            toast.error('Excel dosyası oluşturulurken bir hata oluştu');
        }
    };

    const validateObject = (obj) => {
        var result = true;
        if (document.getElementById("depoAdi").childNodes[0].childNodes[0].value === "") {
            result = false;
            toast.error("Depo Adı boş olamaz");
            return
        }
        if (document.getElementById("bolge").childNodes[0].childNodes[0].value === "") {
            result = false;
            toast.error("Bölge boş olamaz");
            return
        }
        if (document.getElementById("koordinant").value === "") {
            result = false;
            toast.error("Koordinant boş olamaz");
            return
        }
        if (document.getElementById("yon").value === "") {
            result = false;
            toast.error("Yön boş olamaz");
            return
        }
        if (document.getElementById("sira-start").value === "") {
            result = false;
            toast.error("Sıra başlangıç boş olamaz");
            return
        }
        if (document.getElementById("sira-end").value === "") {
            result = false;
            toast.error("Sıra bitiş boş olamaz");
            return
        }
        return result;
    }

    const getWarehouses = async () => {
        try {
            const res = await getAllWarehouses();
            setWarehouses(res);
        }
        catch (error) {
            console.log(error);
        }
    }

    const fetchZones = async (warehouseId) => {
        try {
            const { data } = await api.post('/zone/getZonesByWarehouse', { warehouse_id: warehouseId });
            let all_data = data?.data || [];
            setZones(
                all_data.filter((item) => (item.zone_type == "TYPE_STOCK"))
            )
        } catch {
            //  notify(t("Bölge Listesi Alınırken hata oluştu"), "error");
        }
    };

    return (
        <>
            <Breadcrumb current={t("Adresteki Araçları Boşalt")} />
            <Card className='p-4'>
                <Row>

                    <Col md="6" className="adress-change-criteria">
                        <Row>
                            <Col md="6">
                                <h4>{t("Kriterler")}:</h4>
                            </Col>
                            <Col md="6" className="d-flex justify-content-end">
                                <Button color="warning" className="mt-2" onClick={handleSubmit}>
                                    <i className="fa fa-list"></i>&nbsp;{t("Adresteki Araçları XX1 At")}
                                </Button>
                            </Col>
                        </Row>

                        <hr />
                        <Form>
                            <FormGroup>
                                <Label for="depoAdi" style={{ fontWeight: "bold" }}>{t("Depo Adı")}</Label>
                                <SelectBox
                                    id="depoAdi"
                                    dataSource={warehouses || []}
                                    displayExpr="warehouse_name"
                                    valueExpr="id"
                                    showClearButton={true}
                                    onValueChange={(value) => {
                                        // handleInputChange('depoAdi', value);
                                        setZones([]);
                                        fetchZones(value);
                                    }}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label for="bolge" style={{ fontWeight: "bold" }}>{t("Bölge")}</Label>
                                <SelectBox
                                    id="bolge"
                                    dataSource={zones || []}
                                    displayExpr="zone_name"
                                    showClearButton={true}
                                    valueExpr="id"
                                // onValueChange={(value) => {
                                //     handleInputChange('bolge', value);
                                // }}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label for="koordinant" style={{ fontWeight: "bold" }}>{t("Koordinant")}</Label>
                                <Input
                                    type="text"
                                    id="koordinant"
                                    value={formData?.koordinant}
                                    autoComplete="off"
                                // onChange={(e) => handleInputChange("koordinant", e.target.value)}
                                //  className={`form-control ${validationErrors.koordinant ? 'is-invalid' : ''}`}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label for="yon" style={{ fontWeight: "bold" }}>{t("Yön")}</Label>
                                <Input
                                    type="text"
                                    id="yon"
                                    value={formData?.yon}
                                    autoComplete="off"
                                // onChange={(e) => handleInputChange("yon", e.target.value)}
                                //   className={`form-control ${validationErrors.yon ? 'is-invalid' : ''}`}
                                />
                            </FormGroup>

                            <FormGroup>
                                <Label style={{ fontWeight: "bold" }}>{t("Sıra")}</Label>
                                <Row>
                                    <Col md="6">
                                        <Input
                                            type="text"
                                            id="sira-start"
                                            value={formData?.siralama.start}
                                            autoComplete="off"
                                        //  onChange={(e) => handleInputChange("siralama", e.target.value, "start")}
                                        //  className={`form-control ${validationErrors.siralama?.start ? 'is-invalid' : ''}`}
                                        />
                                    </Col>
                                    <Col md="6">
                                        <Input
                                            type="text"
                                            id="sira-end"
                                            value={formData?.siralama.end}
                                            autoComplete="off"
                                        //  onChange={(e) => handleInputChange("siralama", e.target.value, "end")}
                                        //  className={`form-control ${validationErrors.siralama?.end ? 'is-invalid' : ''}`}
                                        />
                                    </Col>
                                </Row>

                            </FormGroup>
                        </Form>
                    </Col>
                </Row >
                <Row className='w-100'>
                    <Col md="6"
                        className="d-flex justify-content-end">
                        <Button
                            style={{
                                height: "fit-content"
                            }}
                            color="primary" className="mt-2" onClick={fetchAddresses}>
                            <i className="fa fa-list"></i>&nbsp;{t("Listele")}
                        </Button>
                    </Col>
                    <Col md="6"
                        style={{
                            display: 'flex',
                            flexDirection: "column",
                            justifyContent: 'flex-end',
                            alignItems: 'end',
                            textAlign: 'center'
                        }}
                    >
                        <Button
                            style={{
                                width: "30%",
                                minWidth: "fit-content"
                            }}
                            disabled={!showGrid}
                            color='info'
                            className='mt-2' onClick={(e) =>
                                ButtonOnExporting(e, ref, 'Adresteki Araçları Boşalt')}>
                            <i className="fa fa-file-excel-o"></i>&nbsp;{t("Adresleri Aktar")}
                        </Button>
                        <Button
                            style={{
                                width: "30%",
                                minWidth: "fit-content"
                            }}
                            color='success'
                            className='mt-2'
                            disabled={!showMovedVehiclesExport}
                            onClick={exportMovedVehicles}
                        >
                            <i className="fa fa-file-excel-o"></i>&nbsp;{t("Taşınan Araçlar")}
                        </Button>
                    </Col>
                </Row>

                <Row>
                    {
                        loading ? <div className="d-flex justify-content-center w-100 mt-5">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div> :
                            showGrid ? <DatagridCustom
                                // keyExpr="id"
                                dataSource={addresses}
                                showBorders
                                rowAlternationEnabled
                                reff={ref}

                            >
                                <Column dataField="address_code" caption="Adres" alignment='center' />
                                <Column dataField="zone_name" caption="Bölge" alignment='center' />
                                <Column dataField="capacity" caption="Kapasite" alignment='center' />,
                                <Column dataField="used_capacity" caption="Kullanılan Adet" alignment='center' />
                                <Column dataField="status" caption="Durum" alignment='center' calculateDisplayValue={(data) => t(data.status)}
                                />
                                <Scrolling mode='infinite' showScrollbar='always' />
                            </DatagridCustom>
                                : null
                    }
                </Row>
            </Card >
        </>
    )
}

export default AdrestekiAraclariBosalt